module.exports = __webpack_public_path__ + "static/media/fly0276.bde43481.webp";